var map = {
	"./ampere-magnus-ex.md": [
		1560,
		560
	],
	"./ather-450plus.md": [
		47,
		47
	],
	"./ather-450x-gen3.md": [
		3620,
		620
	],
	"./bajaj-chetak.md": [
		6923,
		923
	],
	"./benling-aura.md": [
		9917,
		917
	],
	"./bounce-infinity-e1.md": [
		7657,
		657
	],
	"./hero-vida-v1.md": [
		6491,
		491
	],
	"./ola-s1-pro.md": [
		5743,
		743
	],
	"./ola-s1.md": [
		8513,
		513
	],
	"./tvs-iqube-electric.md": [
		4722,
		722
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 695;
module.exports = webpackAsyncContext;